import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../Webservices/api';
import { apiKeyHeader } from '../../../../configs/ApiKeys';
const API_URL = 'http://localhost:3001/api';

export const fetchSubjects = createAsyncThunk(
  "subjects/fetchSubjects",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();

    const schoolId = state.masterData.school_id;
    const userId = state.authSlice?.user?.id;
    const isIndividualLogin = state.authSlice?.user.roles === 'teacher' || state.authSlice?.user.roles === 'guest_user';

    const response = await api.get(
      `/timetable/subjects/${schoolId}`,
      {
        params: userId && isIndividualLogin ? { user_id: userId } : {},
        headers: apiKeyHeader(),
      }
    );

    return response.data;
  }
);

export const createSubject = createAsyncThunk(
  'subjects/createSubject',
  async (subjectData) => {
    const response = await api.post(`/timetable/subjects`, subjectData, {
      headers: apiKeyHeader()
    });
    return response.data;
  }
);

export const createBulkSubjects = createAsyncThunk(
  'subjects/createBulkSubjects',
  async (subjectsData) => {
    const response = await api.post(`/timetable/subjects/bulk`, subjectsData, {
      headers: apiKeyHeader()
    });
    return response.data;
  }
);

export const updateSubject = createAsyncThunk(
  'subjects/updateSubject',
  async ({ id, data }) => {
    const response = await api.put(`/timetable/subjects/${id}`, data, {
      headers: apiKeyHeader()
    });
    return response.data;
  }
);

export const deleteSubject = createAsyncThunk(
  "subjects/deleteSubject",
  async ({ id, user_id }, { rejectWithValue }) => {
    try {
      await api.delete(
        `/timetable/subjects/${id}/${user_id}`,
        {
          headers: apiKeyHeader(),
        }
      );

      return id;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const subjectSlice = createSlice({
  name: 'subjects',
  initialState: {
    subjects: [],
    loading: false,
    error: null,
    isJoyRideRunning: true,
  },
  reducers: {
    // ✅ ADD THIS
    handleJoyRideRunning(state, action) {
      state.isJoyRideRunning = action.payload;

      action.payload === false &&
        localStorage.setItem("timetableTourCompleted", "true");

    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubjects.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSubjects.fulfilled, (state, action) => {
        state.loading = false;
        state.subjects = action.payload;
      })
      .addCase(fetchSubjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createSubject.fulfilled, (state, action) => {
        state.subjects.push(action.payload);
      })
      .addCase(updateSubject.fulfilled, (state, action) => {
        const index = state.subjects.findIndex(subject => subject.subject_id === action.payload.subject_id);
        if (index !== -1) {
          state.subjects[index] = action.payload;
        }
      })
      .addCase(deleteSubject.rejected, (state, action) => {
        console.log(action, "delete subject error");
        console.log(action?.payload, "delete subjec apyload");
        state.error = action.payload?.error;
      })
      .addCase(deleteSubject.fulfilled, (state, action) => {
        state.subjects = state.subjects.filter(subject => subject.subject_id !== action.payload);
      });
  },
});
export const { handleJoyRideRunning } = subjectSlice.actions;
export default subjectSlice.reducer;
